import React, { useState, useEffect } from "react";
import Provider from "./Provider";
import { useLocation } from "react-router-dom";
import { Loader } from "../../services/helper";

function WalletReport() {
  const { allWallet, isLoading } = Provider();
  const [filteredWallet, setFilteredWallet] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [walletStatusFilter, setwalletStatusFilter] = useState("");
  const rowsPerPage = 10;

  const loc = useLocation().state;

  console.log("All Wallet ::", allWallet);
  console.log("All Wallet LOCATION::", loc);

  useEffect(() => {
    setFilteredWallet(allWallet);
  }, [allWallet]);

  // Search Handler
  useEffect(() => {
    const filtered = allWallet?.filter((wallet) => {
      const matchSearch =
        (wallet?.name?.toLowerCase()?.includes(searchTerm.toLowerCase()) ??
          false) ||
        (wallet?.mobile_number?.includes(searchTerm) ?? false);

      const matchesPaymentStatus =
        walletStatusFilter === "" ||
        (walletStatusFilter === "SUCCESS" && wallet?.status === "SUCCESS") ||
        (walletStatusFilter === "CANCEL" && wallet?.status === "CANCEL") ||
        (walletStatusFilter === "PENDING" && wallet?.status === "PENDING");

      return matchSearch && matchesPaymentStatus;
    });
    setFilteredWallet(filtered);
    setCurrentPage(1);
  }, [searchTerm, walletStatusFilter, allWallet]);

  // Pagination Logic
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentWallet = filteredWallet?.slice(startIndex, endIndex);

  const totalPages = Math.ceil(filteredWallet?.length / rowsPerPage);

  return (
    <div className="p-2 bg-white shadow-xl font-Poppins rounded-xl mx-4">
      <div className="flex items-center justify-between px-4 py-4 ">
        <h1 className="text-2xl font-semibold ">
          All {loc?.role === "Driver" && loc?.role} Wallet Report
        </h1>

        {/* Search Bar */}

        <div className="flex items-center w-1/3 gap-2 ">
          <select
            value={walletStatusFilter}
            onChange={(e) => setwalletStatusFilter(e.target.value)}
            className="border border-gray-300 rounded-lg px-6 py-2 text-md font-medium focus:outline-none focus:ring focus:border-blue-300"
          >
            <option value="" className="font-medium">
              All
            </option>
            <option value="SUCCESS" className="font-medium">
              Success
            </option>
            <option value="PENDING" className="font-medium">
              Pending
            </option>
            <option value="CANCEL" className="font-medium">
              Cancel
            </option>
          </select>

          <div className="relative w-full w-1/2">
            <input
              type="text"
              placeholder="Search..."
              className="border border-gray-300 rounded-lg px-4 py-2 pr-10 w-full focus:outline-none focus:ring focus:border-blue-300"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm && (
              <button
                type="button"
                className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700 focus:outline-none"
                onClick={() => setSearchTerm("")}
              >
                ✕
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Table */}

      {isLoading ? (
        <>
          <div className="flex my-[10%] justify-center items-center">
            <div className="w-8 h-8 border-4 border-t-4 border-gray-200 border-solid rounded-full animate-spin border-t-blue-500"></div>
          </div>
        </>
      ) : (
        <>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
              {currentWallet ? (
                <>
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="px-3 py-3 text-left text-sm font-medium text-gray-600">
                        S No.
                      </th>

                      {loc?.role === "Driver" && (
                        <>
                          <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                            Driver Name & Mobile
                          </th>
                          <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                            Current Wallet Amount
                          </th>
                        </>
                      )}

                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                        Order Id & Payment Id
                      </th>

                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                        Transaction Type
                      </th>

                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                        Payment Method
                      </th>

                      {!loc?.role && (
                        <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                          Driver Name & Mobile
                        </th>
                      )}

                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                        Top-Up Amount
                      </th>

                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                        Payement Status
                      </th>

                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                        Created At
                      </th>
                      {/* <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                Action
              </th> */}
                    </tr>
                  </thead>
                  <tbody className="text-sm divide-y divide-gray-200">
                    {currentWallet?.map((wallet, index) => (
                      <tr key={wallet?.id}>
                        <div className="px-6 py-4 flex items-center">
                          {index + 1}
                        </div>

                        {loc?.role === "Driver" && (
                          <>
                            <td className="px-6 py-4">
                              <div className="font-medium">{wallet?.name}</div>
                              <div className="text-gray-500">
                                {wallet?.mobile_number}
                              </div>
                            </td>
                            <td className="px-6 py-4">
                              {wallet?.wallet_amount || "--"}
                            </td>
                          </>
                        )}

                        <td className="px-6 py-4">
                          <div className="font-medium my-1">
                            {wallet?.order_id || "--"}
                          </div>
                          <div className="font-medium my-1">
                            {wallet?.payment_id || "--"}
                          </div>
                        </td>
                        <td className="px-6 py-4 font-medium">
                          <span
                            className={`px-2 py-1 text-xs font-semibold cursor-pointer rounded-lg ${
                              wallet?.transaction_type === "CREDIT"
                                ? "text-green-600 bg-green-100"
                                : wallet?.transaction_type === "REFUND"
                                ? " text-gray-600 bg-gray-100"
                                : "text-red-600 bg-red-100"
                            }`}
                          >
                            {wallet?.transaction_type || "--"}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          {wallet?.payment_method === "upi" ? (
                            <>
                              <div>
                                Payment Method:{" "}
                                <span className="font-bold">UPI</span>
                              </div>
                              <div>
                                Transaction ID:{" "}
                                <span className="font-bold">
                                  {wallet?.upi_transaction_id || "--"}
                                </span>
                              </div>
                            </>
                          ) : wallet?.payment_method === "netbanking" ? (
                            <>
                              <div>
                                Payment Method:{" "}
                                <span className="font-bold">Netbanking</span>
                              </div>
                              <div>
                                Bank:{" "}
                                <span className="font-bold">
                                  {wallet?.bank}
                                </span>
                              </div>
                              <div>
                                Transaction Details:{" "}
                                <span className="font-bold">
                                  {wallet?.bank_transaction_id || "--"}
                                </span>
                              </div>
                            </>
                          ) : wallet?.payment_method === "Wallet" &&
                            wallet?.transaction_type === "REFUND" ? (
                            <>
                              <div className="font-bold">
                                Return Services Charges
                              </div>
                              <div className="font-medium">
                                Reason:{" "}
                                <span className="font-bold">
                                  Cancelled Ride By Customer
                                </span>
                              </div>
                            </>
                          ) : wallet?.payment_method === "Wallet" ? (
                            <>
                              <div className="font-bold">Services Charges</div>
                            </>
                          ) : (
                            "--"
                          )}
                        </td>

                        {!loc?.role && (
                          <td className="px-6 py-4">
                            <div className="font-medium">{wallet?.name}</div>
                            <div className="text-gray-500">
                              {wallet?.mobile_number}
                            </div>
                          </td>
                        )}

                        <td className="px-6 py-4">{wallet?.amount || "--"}</td>

                        <td className="px-6 py-4">
                          <span
                            // onClick={() => handleAccountStatusChange(driver)}
                            className={`px-2 py-1 text-xs font-semibold cursor-pointer rounded-lg ${
                              wallet?.status === "SUCCESS"
                                ? "text-green-600 bg-green-100"
                                : wallet?.status === "PENDING"
                                ? " text-gray-600 bg-gray-100"
                                : "text-red-600 bg-red-100"
                            }`}
                          >
                            {wallet?.status}
                          </span>
                        </td>

                        <td className="px-6 py-4">
                          {new Date(wallet?.created_at).toLocaleDateString(
                            "en-GB"
                          )}
                        </td>

                        {/* <td className="px-6 py-4">
                  <button className="text-green-600 hover:text-green-800 mx-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="size-6 cursor-pointer mr-2"
                      //   onClick={() => ViewRow(driver)}
                    >
                      <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                      <path
                        fillRule="evenodd"
                        d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                  <button className="text-red-600 hover:text-red-800 mx-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="size-6 cursor-pointer"
                      //   onClick={() => DeleteRow(driver)}
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </td> */}
                      </tr>
                    ))}
                  </tbody>
                </>
              ) : (
                <>
                  <div className="my-[10%] font-medium font-Poppins text-3xl flex items-center justify-center">
                    No Wallet Report!
                  </div>
                </>
              )}
            </table>
          </div>
        </>
      )}

      {/* Pagination */}

      {currentWallet && (
        <div className="flex justify-between items-center mt-4">
          <span className="text-sm text-gray-600">
            Showing {startIndex + 1}-
            {Math.min(endIndex, filteredWallet?.length)} of{" "}
            {filteredWallet?.length}
          </span>
          <div className="flex">
            <button
              className="px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-200"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <button
              className="px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-200 ml-2"
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default WalletReport;
